import EffectAmount from '@/roc/effects/EffectAmount';
class EffectMod extends EffectAmount {
    apply(value) {
        return value;
    }
}
export default EffectMod;
